// src/pages/po/SaldoRedeModalContent.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked, faRectangleXmark } from '@/icons';
import ScrollableTable from '../../components/common/ScrollableTable';
import { SaldoRede } from '../../types/saldo/SaldoRede';
import './SaldoRedeModalContent.css';

interface SaldoRedeModalContentProps {
  saldos: SaldoRede[];
  isOpen: boolean;
  onClose: () => void;
  theme: 'dark' | 'light';
  showCancelButton?: boolean;
}

const SaldoRedeModalContent: React.FC<SaldoRedeModalContentProps> = ({
  saldos,
  isOpen: _isOpen,
  onClose,
  theme,
  showCancelButton = true,
}) => {
  // Modal sem paginação: hasMore/isLoading constantes; checkboxes desativados → onSelectChange é no-op
  const hasMore = false;
  const isLoading = false;

  // Como todos os itens têm o mesmo codProduto, codCategoria, nomeProduto e nomeCategoria,
  // pegamos do primeiro item
  const { codProduto, codCategoria, nomeProduto, nomeCategoria } = saldos[0] || {};

  const loadMore = () => {};

  // Definição das colunas da tabela
  const columns = [
    {
      header: 'Filial',
      render: (saldo: SaldoRede) => saldo.nomeFantasia,
    },
    {
      header: 'Estoque Disponível',
      render: (saldo: SaldoRede) => saldo.qtdDisponivel,
    },
    {
      header: 'Preço',
      render: (saldo: SaldoRede) => `R$ ${saldo.precoVenda.toFixed(2)}`,
    },
  ];

  return (
    <div className={`saldo-rede-modal-content ${theme}`}>
      <div className="modal-header">
        <h4><FontAwesomeIcon icon={faBoxesStacked} style={{ marginRight: '8px' }} /> Saldo por Filial</h4>
      </div>
      <div className="product-info">
        <p>
          Código: {codProduto} | Cód. Categoria: {codCategoria} | Descrição: {nomeProduto} | Categoria: {nomeCategoria}
        </p>
      </div>
      <ScrollableTable<SaldoRede>
        data={saldos}
        hasMore={hasMore}
        loadMore={loadMore}
        isLoading={isLoading}
        columns={columns}
        onSelectChange={() => {}}
        showCheckboxes={false} // Desativa os checkboxes
        emptyMessage="Nenhum saldo disponível."
      />
      {showCancelButton && (
        <div className="form-actions">
          <button onClick={onClose} className="cancel-button">
            <FontAwesomeIcon icon={faRectangleXmark} /> Cancelar
          </button>
        </div>
      )}
    </div>
  );
};

export default SaldoRedeModalContent;